
import Vue, { PropType } from 'vue';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useColorsManagementStore } from '@/stores/v2/colorsManagement';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import { useStore as useHistoryStore } from '@/stores/v2/history';
import { useStore as useLangStore } from '@/stores/v2/lang';
import { mapState, mapActions } from 'pinia';
import PrintPositionBox from '../PositionsManagement/PrintPositionBox.vue';
import Add32 from '@carbon/icons-vue/es/add/32';
import PrintPositionsModal from './PrintPositionsModal.vue';
import { generateEventPayload } from '@/utils/generatePriceParamsEventPayload';
import { createStateSnapshot } from '@/utils/historyHelper';
import { ProductPrintPositionAddModel } from '@/typings';
import { CvModal, CvButton } from '@carbon/vue';

export default Vue.extend({
  name: 'PrintPositions',
  components: {
    PrintPositionBox,
    Add32,
    PrintPositionsModal,
    CvModal,
  },

  props: {
    sapCustomerId: {
      type: String,
      required: true,
    },
    tok: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      editId: '',
      yesNoDialog: false,
      positionToDelete: {} as ProductPrintPositionAddModel,
    };
  },

  computed: {
    ...mapState(useProductStore, [
      'data',
      'activePosition',
      'printPositions',
      'selectedPrintPosition',
      'unavailablePrintPositions',
    ]),
    ...mapState(useLangStore, ['languageInUse']),
    techniqueNameTranslated(): string {
      const position = this.printPositions?.find(
        (p) => p.id === this.positionToDelete.positionId
      );
      const technique = position?.printTechniques.find((technique) => {
        return technique.id === this.positionToDelete.technique.id;
      });
      const techniqueName = technique?.printTechnique.nameTranslations.find(
        ({ language }) => language.code === this.languageInUse
      )?.text;
      return techniqueName || this.selectedPrintPosition.techniqueName || '';
    },
  },

  methods: {
    ...mapActions(useProductStore, [
      'deletePrintPosition',
      'setPreviousManagedPrintPositionId',
    ]),
    ...mapActions(useMirrorStore, ['removePositionMirrorSettings']),
    ...mapActions(useColorsManagementStore, ['getAvailablePmsColors']),
    ...mapActions(useHistoryStore, ['recordHistory']),
    openModal(id = '') {
      this.editId = id;
      this.$modal.show('print-positions-modal');
    },
    actionDeletePrintPosition(position: ProductPrintPositionAddModel) {
      this.positionToDelete = position;
      this.yesNoDialog = true;
    },
    actionEditPrintPosition(id: string) {
      this.setPreviousManagedPrintPositionId(id);
      this.openModal(id);
    },
    async onDeletePrintPosition(deleteId: string) {
      await this.deletePrintPosition(this.positionToDelete.positionId);

      this.removePositionMirrorSettings(deleteId);

      const eventPayload = generateEventPayload();

      this.$emit('wizard:price-params-changed', {
        productPrintPositions: eventPayload,
      });

      await this.getAvailablePmsColors();

      const snapshot = createStateSnapshot();
      this.recordHistory(snapshot);
    },
  },
});
